import React from 'react';
import FlatButton from 'material-ui/FlatButton';

import { m } from '../../utils';

const InfoNA = ({ openDialog, bookingId, startTime }) => (
  <div>
    <p>
      Car details and further information will be available within 10 minutes of your shift. Please check back with us
      soon.
    </p>
    {startTime && m(startTime).isAfter(m().add(48, 'hours')) ? (
      <FlatButton className="pull-right" onClick={() => openDialog('delete', bookingId)} style={{ color: 'red' }}>
        Cancel Shift
      </FlatButton>
    ) : null}
  </div>
);

export default InfoNA;



// WEBPACK FOOTER //
// ./src/components/Dashboard/InfoNA.js